/* eslint-enable */
/* eslint-enable */

class AnimationImageOverflowBottom {
	
	constructor(args = { sectionsContainer: document }) {
		this.sectionsContainer = args.sectionsContainer;
		this.$moduleImageOverflowBottom = this.sectionsContainer.querySelectorAll('.image-overflow-bottom');
		
		if (!this.$moduleImageOverflowBottom)
			return;
		
		this.$moduleImageOverflowBottomElements = [];
		this.$moduleImageOverflowBottom.forEach(module => {
			this.$moduleImageOverflowBottomElements.push(module.querySelectorAll('.anima'));	
		});
		
		this.init();
	}

	/* eslint-disable class-methods-use-this, no-unused-vars */
	init() {
		this.setAnimation();
	}

	setAnimation() {
		this.$moduleImageOverflowBottom.forEach((modile, index) => {
			gsap.set(module, { opacity: 1});
	        gsap.set(this.$moduleImageOverflowBottomElements[index], { yPercent: 20, opacity: 0, onComplete: () => {
				this.initAnimate(index);
			} });	
		});
	}

	initAnimate(index) {
		const moduleImageOverflowBottom = gsap.timeline({
			defaults: { duration: 1.2, ease: 'power4.out' },
            scrollTrigger: {
                trigger: this.$moduleImageOverflowBottom[index],
				start: '-20% 50%'
				//start: 'top 100%'
			},
			onComplete: () => {
				gsap.set(this.$moduleImageOverflowBottomElements[index], { clearProps: true });
			}
        });
    
        moduleImageOverflowBottom.addLabel('step1');
        moduleImageOverflowBottom.to(this.$moduleImageOverflowBottom[index], { opacity: 1, duration: 1 }, 'step1');
		moduleImageOverflowBottom.to(this.$moduleImageOverflowBottomElements[index], { yPercent: 0, opacity: 1, stagger: 0.2 }, 'step1+=0.3');
	}
	/* eslint-enable class-methods-use-this, no-unused-vars */
}
export default AnimationImageOverflowBottom;